import React from 'react';
import ReactDOM from 'react-dom/client';
import './CSS/Main.css';
import './CSS/ButtonAndIcon.css'
import './CSS/Inputs.css'
import './CSS/Media.css'
import App from './App';
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { Provider } from "react-redux";
import RevenueSlice from './Reducer/RevenueSlice';
import CitySlice from './Reducer/CitySlice';
import StaffSlice from './Reducer/StaffSlice';
import ModalSlice from './Reducer/ModalSlice';
import AddStaffSlice from './Reducer/AddStaffSlice';
import MonthSlice from './Reducer/MonthSlice';
import PeriodSlice from './Reducer/PeriodSlice';
import UserSlice from './Reducer/UserSlice';
import AddUserSlice from './Reducer/AddUserSlice';
import Header from './Header';
import ArticleSlice from './Reducer/ArticleSlice';
import MonthSliceAR from './Reducer/MonthSliceAR';
import AdvanceReprotsSlice from './Reducer/AdvanceReprotsSlice';
import AddArticleInARSlice from './Reducer/AddArticleInARSlice';
import AddArticleInAPISlice from './Reducer/AddArticleInAPISlice';
import RevenueModuleSlice from './Reducer/RevenueModuleSlice';


const rootReducer = combineReducers({
    RevenueSlice,
    CitySlice,
    StaffSlice,
    ModalSlice,
    AddStaffSlice,
    MonthSlice,
    PeriodSlice,
    UserSlice,
    AddUserSlice,
    ArticleSlice,
    MonthSliceAR,
    AdvanceReprotsSlice,
    AddArticleInARSlice,
    AddArticleInAPISlice,
    RevenueModuleSlice,
})

export const store = configureStore({
    reducer: rootReducer,
})


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store = {store}>
        <Header/>
        <App/>
    </Provider>
);


